import { apiClient } from "../apiClient";
export const CHUONG_TRINH_DAO_TAO_KIEN_THUC_ENDPOINT =
  "chuong-trinh-dao-tao-kien-thuc";
export const chuongTrinhDaoTaoKienThucApi = {
  SelectAll: () => apiClient.get(`${CHUONG_TRINH_DAO_TAO_KIEN_THUC_ENDPOINT}`),
};
